import { render, staticRenderFns } from "./highchart.vue?vue&type=template&id=20427486&scoped=true&"
import script from "./highchart.vue?vue&type=script&lang=js&"
export * from "./highchart.vue?vue&type=script&lang=js&"
import style0 from "./highchart.vue?vue&type=style&index=0&id=20427486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20427486",
  null
  
)

export default component.exports